import { BehaviorSubject } from 'rxjs';
import { INDRATAPUserProfile } from '@ibe.models/user.indra.model.lib';
import * as i0 from "@angular/core";
var LoginModalService = /** @class */ (function () {
    function LoginModalService() {
        this.currentDataUser = new BehaviorSubject(this.dataUser);
    }
    LoginModalService.prototype.sendDataCustomer = function (dataCustomer) {
        this.dataUser = dataCustomer;
        this.currentDataUser.next(this.dataUser);
    };
    LoginModalService.prototype.getObject = function () {
        return this.currentDataUser.asObservable();
    };
    LoginModalService.ngInjectableDef = i0.defineInjectable({ factory: function LoginModalService_Factory() { return new LoginModalService(); }, token: LoginModalService, providedIn: "root" });
    return LoginModalService;
}());
export { LoginModalService };
